function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.262 10.788a2.27 2.27 0 01-.77-1.73c0-1.363 1.027-2.055 1.946-2.686.791-.529 1.497-.997 1.497-1.79 0-.794-.642-1.466-2.031-1.466-1.304 0-2.245.57-2.972 1.425L3.5 3.015C4.59 1.753 6.236 1 8.16 1c2.694 0 4.34 1.363 4.34 3.195 0 1.689-1.197 2.503-2.266 3.215-.812.57-1.56 1.058-1.56 1.872 0 .326.192.692.47.916l-1.882.59zM8.032 15c-.812 0-1.496-.651-1.496-1.424 0-.774.684-1.425 1.496-1.425.812 0 1.496.651 1.496 1.425 0 .773-.684 1.424-1.496 1.424z",
  fill: "currentColor"
})));